export default __webpack_public_path__ + "static/media/postOne.28a445b0.mp4";